import { clinicsFetch } from '../functions/fetchClinics.js'

export const clinics = {
  extends: 'Page',
  flow: 'y',
  background: 'white',
  color: '#1D1D1F',

  ClinicsData: { fetch: clinicsFetch, display: 'none' },

  NavBar: {
    background: 'rgba(255,255,255,0.85)',
    backdropFilter: 'blur(16px)',
    borderBottom: '1px solid rgba(0,0,0,0.06)'
  },

  HeroHeader: {
    tag: 'section',
    flow: 'y',
    align: 'center center',
    textAlign: 'center',
    padding: 'D B C B',
    width: '100%',
    background: 'linear-gradient(180deg, #F0F0F5 0%, #FFFFFF 100%)',
    '@mobileL': { padding: 'C A B A' },

    PageTitle: {
      tag: 'h1',
      text: '{{ clinicsTitle | polyglot }}',
      fontSize: 'E',
      fontWeight: '700',
      letterSpacing: '-0.03em',
      color: 'inkText'
    },
    PageSubtitle: {
      text: (el, s) => (s.root.clinics || []).length + ' {{ verifiedClinics | polyglot }}',
      fontSize: 'A',
      color: 'inkMuted',
      marginTop: 'Y'
    },

    SearchBar: {
      flow: 'x',
      align: 'center center',
      gap: 'Y',
      width: '100%',
      maxWidth: 'J',
      margin: 'C1 - -',
      '@mobileL': { flow: 'y' },

      SearchInput: {
        tag: 'input',
        type: 'text',
        placeholder: '{{ searchByName | polyglot }}',
        flex: '1',
        padding: 'Z1 A',
        round: 'C',
        background: '#FFFFFF',
        color: '#1D1D1F',
        border: '1px solid rgba(0,0,0,0.1)',
        fontSize: 'Z',
        outline: 'none',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
        transition: 'all 0.2s ease',
        ':focus': { border: '1px solid rgba(0,0,0,0.2)', boxShadow: '0 4px 16px rgba(0,0,0,0.08)' },
        onInput: (e, el, s) => s.root.update({ clinicFilter: el.node.value })
      },

      MapToggleBtn: {
        tag: 'button',
        flow: 'x',
        align: 'center center',
        gap: 'W',
        background: (el, s) => s.root.showClinicsMap ? '#0D1117' : '#FFFFFF',
        color: (el, s) => s.root.showClinicsMap ? '#FFFFFF' : '#1D1D1F',
        fontWeight: '500',
        padding: 'Z1 A',
        round: 'C',
        fontSize: 'Z',
        cursor: 'pointer',
        border: '1px solid rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease',
        flexShrink: '0',
        onClick: (e, el, s) => s.root.update({ showClinicsMap: !s.root.showClinicsMap }),
        MapIcon: { extends: 'Icon', icon: 'mapPin', width: 'Z2', height: 'Z2' },
        MapLabel: { text: (el, s) => s.root.showClinicsMap ? '{{ hideMap | polyglot }}' : '{{ showMap | polyglot }}' }
      },
      NearMeBtn: {
        tag: 'button',
        flow: 'x',
        align: 'center center',
        gap: 'W',
        background: '#FFFFFF',
        color: 'teal',
        fontWeight: '500',
        padding: 'Z1 A',
        round: 'C',
        fontSize: 'Z',
        cursor: 'pointer',
        border: '1px solid rgba(0,0,0,0.1)',
        flexShrink: '0',
          transition: 'all 0.2s ease',
          ':hover': { background: 'teal.05' },
          onClick: (e, el, s) => {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                (pos) => s.root.update({ userLat: pos.coords.latitude, userLng: pos.coords.longitude, locationShared: true }),
                () => alert('Location access denied.')
              )
            }
          },
          NearIcon: { extends: 'Icon', icon: 'mapPin', width: 'Z2', height: 'Z2' },
          NearLabel: { text: '{{ nearMe | polyglot }}' }
        }
    },

    ResultCount: {
      text: (el, s) => {
        const q = s.root.clinicFilter
        if (!q) return ''
        const n = (s.root.clinics || []).filter(c => {
          const lower = q.toLowerCase()
          return c.name.toLowerCase().includes(lower) || c.district.toLowerCase().includes(lower) || (c.services || []).some(sv => sv.toLowerCase().includes(lower))
        }).length
        return n + ' clinics match "' + q + '"'
      },
      fontSize: 'Y',
      color: 'inkMuted',
      marginTop: 'Y'
    }
  },

  ContentLayout: {
    display: 'grid',
    gridTemplateColumns: (el, s) => s.root.showClinicsMap ? '2fr 1fr' : '1fr',
    gap: 'A',
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    padding: 'B B',
    alignItems: 'start',
    '@tabletS': { gridTemplateColumns: '1fr' },
    '@mobileL': { gridTemplateColumns: '1fr', padding: 'A' },

    ClinicGrid: {
      flow: 'y',
      gap: 'A',
      minWidth: '0',

      GridInner: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(max(320px, calc((100% - 4 * 15px) / 5)), 1fr))',
        '@mobileL': { gridTemplateColumns: '1fr' },
        gap: 'A',
        children: (el, s) => {
          const clinics = s.root.clinics || []
          const q = s.root.clinicFilter
          let filtered = clinics
          if (q) {
            const lower = q.toLowerCase()
            filtered = clinics.filter(c =>
              c.name.toLowerCase().includes(lower) ||
              c.district.toLowerCase().includes(lower) ||
              (c.services || []).some(sv => sv.toLowerCase().includes(lower))
            )
          }
          return filtered.slice(0, s.root.clinicsVisible || 24)
        },
        childrenAs: 'state',
        childExtends: 'ClinicListCard'
      },

      LoadMoreTrigger: {
        show: (el, s) => (s.root.clinics || []).length > (s.root.clinicsVisible || 24),
        height: 'C',
        flow: 'x',
        align: 'center center',
        onRender: (el, s) => {
          if (el.node._observer || typeof IntersectionObserver === 'undefined') return
          el.node._observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              const current = s.root.clinicsVisible || 24
              const total = (s.root.clinics || []).length
              if (current < total) {
                s.root.update({ clinicsVisible: Math.min(current + 24, total) })
              }
            }
          }, { threshold: 0.1 })
          el.node._observer.observe(el.node)
        },
        LoadMoreText: {
          text: (el, s) => {
            const visible = s.root.clinicsVisible || 24
            const total = (s.root.clinics || []).length
            return visible < total ? '{{ loadingMore | polyglot }}' : ''
          },
          fontSize: 'Z',
          color: 'inkMuted'
        }
      }
    },

    MapPanel: {
      flow: 'y',
      position: 'sticky',
      top: 'C',
      height: 'calc(100vh - 80px)',
      show: (el, s) => !!s.root.showClinicsMap,
      '@tabletS': { position: 'static', height: '400px' },
      '@mobileL': { height: '300px' },

      MapContainer: {
        width: '100%',
        height: '100%',
        round: 'A',
        overflow: 'hidden',
        attr: { id: 'clinics-page-map' },
        onRender: (el, s) => {
          if (el.node._mapInit) return
          el.node._mapInit = true

          const initMap = () => {
            const mapStyles = [
              { featureType: 'poi', stylers: [{ visibility: 'off' }] },
              { featureType: 'transit', stylers: [{ visibility: 'off' }] },
              { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e3e8ee' }] },
              { featureType: 'landscape', stylers: [{ color: '#f5f5f5' }] },
              { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
              { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#e8e8e8' }] }
            ]

            const map = new google.maps.Map(el.node, {
              center: { lat: 41.715, lng: 44.78 },
              zoom: 13,
              styles: mapStyles,
              disableDefaultUI: true,
              zoomControl: true,
              zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP }
            })

            const clinics = s.root.clinics || []
            clinics.forEach(c => {
              if (!c.lat || !c.lng) return
              const marker = new google.maps.Marker({
                position: { lat: c.lat, lng: c.lng },
                map,
                title: c.name,
                icon: {
                  path: 'M12 2C9.5 2 7 3.5 6 5.5c-1.5 3-.5 5 0 7.5.5 2.5-.5 5.5 1 8 .5.8 1.5 1 2 1s1-.5 1.5-2c.5-1.5 1-2 1.5-2s1 .5 1.5 2c.5 1.5 1 2 1.5 2s1.5-.2 2-1c1.5-2.5.5-5.5 1-8 .5-2.5 1.5-4.5 0-7.5C17 3.5 14.5 2 12 2z',
                  fillColor: '#0D1117',
                  fillOpacity: 1,
                  strokeColor: '#FFFFFF',
                  strokeWeight: 2,
                  scale: 1.2,
                  anchor: new google.maps.Point(12, 22)
                }
              })
              const info = new google.maps.InfoWindow({
                content: '<div style="font-family:system-ui;padding:4px"><b>' + c.name + '</b><br><span style="color:#00C9A7">' + c.district + '</span><br>★ ' + c.rating + '</div>'
              })
              marker.addListener('click', () => info.open(map, marker))
            })
          }

          if (window.google && window.google.maps) {
            initMap()
          } else {
            window.initClinicsMap = initMap
            const script = document.createElement('script')
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAIjI_gvh-OUSEdzgfHKh2v1GvwiEp2Ztg&callback=initClinicsMap'
            script.async = true
            script.defer = true
            document.head.appendChild(script)
          }
        }
      }
    }
  }
}
